import OperatorLanguageSelector from '@/shared/components/LanguageSelector'
import { Card } from '@/common'
import AuthImageCarousel from './AuthImageCarousel'

function LogoSymbol({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="-75 -75 300 300" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          fill="currentColor"
          d="m43.08 63.57h-42.08v22h45.27c9.86 0 17.86 8 17.86 17.86v45.27h22v-42.08c0-2.26-0.9-4.42-2.5-6.02l-34.53-34.53c-1.6-1.6-3.77-2.5-6.02-2.5z"
        />
        <path
          fill="currentColor"
          d="m107.62 85.13h42.08v-22h-45.27c-9.86 0-17.86-7.99-17.86-17.85v-45.28h-22v42.08c0 2.26 0.9 4.43 2.5 6.02l34.53 34.53c1.6 1.6 3.76 2.5 6.02 2.5z"
        />
      </g>
    </svg>
  )
}

export default function AuthLayout({
  children,
  showCarousel = true
}: {
  children: React.ReactNode
  showCarousel?: boolean
}) {
  return (
    <div className="flex flex-col items-center h-screen justify-center px-4">
      <Card className="inline-block">
        <div
          className={`flex flex-col lg:flex-row lg:items-center ${showCarousel ? 'lg:gap-12' : ''} px-6 md:px-8 lg:px-12 py-6`}
        >
          <div className="shrink-0 w-full lg:w-auto">
            <header className="flex flex-col items-center justify-center font-aspekta mb-6 md:mb-8">
              <div>
                <LogoSymbol className="w-16 h-16 md:w-20 md:h-20 text-[#02FFD8]" />
              </div>
              <div className="text-center">
                <span className="font-bold text-2xl md:text-3xl lg:text-4xl">
                  Artem
                  <span className="text-green-500">CBAM™</span>
                </span>
                <span className="text-base md:text-lg font-semibold uppercase ml-2">Operator</span>
              </div>
            </header>
            {children}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 mt-4 md:mt-6">
              <div className="text-xs text-text-secondary font-medium">
                <p>© {new Date().getFullYear()} Artem Technologie AG</p>
              </div>
              <span
                className="hidden sm:inline"
                style={{ fontWeight: 600, fontSize: '14px', color: '#24262D' }}
              >
                •
              </span>
              <OperatorLanguageSelector showLabel />
            </div>
          </div>
          {showCarousel && (
            <div className="hidden lg:flex items-center justify-center shrink-0">
              <AuthImageCarousel />
            </div>
          )}
        </div>
      </Card>
    </div>
  )
}
